import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { SessionManager } from '../common/helpers/session-manager';
import { ProductService } from '../shopping-cart/services/product.service';
import { Order } from '../common/models/order';
import { LaddaModule } from 'angular2-ladda';

@Component({
  selector: 'app-path-recommendation',
  templateUrl: './path-recommendation.component.html',
  styleUrls: ['./path-recommendation.component.css']
})
export class PathRecommendationComponent implements OnInit {

  suggestionList : string[];
  selectedOrder : string;
  promoCode: string;
  isMember: boolean;

  constructor(private sessionManager: SessionManager, private productService: ProductService, private router: Router) {
  }

  ngOnInit() {
    this.suggestionList = this.sessionManager.getUserDataForRecommendation();
    this.selectedOrder = this.suggestionList[0];
    this.promoCode = this.sessionManager.getPromoCode();
    this.isMember = this.sessionManager.getCurrentUser().isMemberExpired;
  }

  selectedOptionType(productType: string){   
    this.selectedOrder = productType;
  }

  recomondedProductType(selectedOption: any){ 
    debugger;  
    this.sessionManager.setPromoCode(selectedOption.code);
    this.productService.getProductsByProductCode().subscribe((response: any) => {  
      setTimeout(()=>{ this.router.navigate(['order']); }, 1000);
    });    
  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/path-recommendation/path-recommendation.component.ts